// Escala mobile-first herdada da escala de-facto do projeto (600/800/1000/1366),
// para que a migração das media queries legadas seja majoritariamente uma
// renomeação sem mudança visual.
//
// Arquivo propositalmente sem dependência de styled-components: pode ser
// importado por lógica JS (ex.: configuração do react-slick).
export const breakpoints = {
  xs: 480,
  sm: 600,
  md: 800,
  lg: 1000, // ponto de troca MenuMobile <-> MenuDesktop
  xl: 1366,
  xxl: 1600,
};
